/**
 * Spread onto an element to make its whole subtree NON-interactive — not clickable,
 * not focusable, not editable — when `on` is true (the HTML `inert` attribute).
 *
 * Used for the Sample Registration read-only mode (Module Access Control: a user
 * with only Read, or without the Write / Create right for this record, opens it in
 * View mode like ALPACA). React 18's typings do not know `inert`, so it is spread
 * from an untyped object; React passes the attribute straight to the DOM.
 */
export const inertProps = (on: boolean): Record<string, unknown> => (on ? { inert: '' } : {});
